/* Date Fns */
import { format, parseISO } from 'date-fns';

export const makeDate_Std = (dt) => format(parseISO(dt),formatDateStd);
export const makeTime = (dt) => format(parseISO(dt),formatTimeStd);

// formats: https://date-fns.org/v2.29.1/docs/format
export const formatDateStd = 'd MMM yyyy hh:mm a';
export const formatTimeStd = 'hh:mm a';
